import { EXCHANGE_ALIASES } from './exchangeCatalog'

/** Matches capabilities.canonical_exchange_name through its generated registry. */
export function canonicalExchangeName(value: string): string {
  const name = value.trim().toLowerCase()
  return EXCHANGE_ALIASES[name] || name
}

export function canonicalExchangeScope(values: string[]): string[] {
  return [...new Set(values.map(canonicalExchangeName).filter(Boolean))]
}

/** Use an available source without overwriting the user's preferred source. */
export function resolveScreenerPriceExchange(preferred: string, available: string[]): string {
  const names = canonicalExchangeScope(available)
  const wanted = canonicalExchangeName(preferred)
  if (wanted && names.includes(wanted)) return wanted
  return names.includes('binance') ? 'binance' : names[0] || ''
}
